(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/proxy.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/proxy.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const getLogger = svs.isServer ? trinidad.logger : svs.core.log.getLogger;
const drawHandlers = svs.isServer ? require('./handlers/draw-handlers.es6') : svs.components.lbUtils.apiProxy.handlers.drawHandlers;
const playerHandlers = svs.isServer ? require('./handlers/player-handlers.es6') : svs.components.lbUtils.apiProxy.handlers.playerHandlers;
let legacyFetch;
let cloudFetch;
if (!svs.isServer) {
  legacyFetch = trinidad.jupiterFetch.fetch;
  cloudFetch = trinidad.svsFetch.create();
} else {
  cloudFetch = async function cloudFetch(path) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const svsFetch = trinidad.svsFetch(options.req);
    return svsFetch(path, options);
  };
  legacyFetch = async function legacyFetch(path) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise((resolve, reject) => {
      const fetchOptions = {
        method: options.method || 'GET',
        path,
        req: options.req
      };
      trinidad.jupiter.call(fetchOptions, (err, data) => {
        if (err) {
          reject(data || err);
        } else {
          resolve({
            ok: true,
            json: async () => data
          });
        }
      });
    });
  };
}
const logger = getLogger('lb-utils:api-proxy');

class ApiProxy {
  constructor() {
    let handlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let {
      legacyTransport,
      cloudTransport
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.legacyTransport = legacyTransport !== null && legacyTransport !== void 0 ? legacyTransport : legacyFetch;
    this.cloudTransport = cloudTransport !== null && cloudTransport !== void 0 ? cloudTransport : cloudFetch;
    if (!Array.isArray(handlers)) {
      throw new TypeError('Handlers should be an array');
    }
    this.handlers = handlers;
  }
  addHandlers(handlerOrHandlers) {
    if (Array.isArray(handlerOrHandlers)) {
      this.handlers.push(...handlerOrHandlers);
    } else {
      this.handlers.push(handlerOrHandlers);
    }
    return this;
  }
  removeHandler(handler) {
    const index = this.handlers.indexOf(handler);
    if (index !== -1) {
      this.handlers.splice(index, 1);
    }
  }
  async findHandler(url) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const upperMethod = String(options.method || 'GET').toUpperCase();
    for (let i = 0; i < this.handlers.length; i++) {
      const handler = this.handlers[i];
      if (handler.method !== upperMethod) {
        continue;
      }

      const {
        matches,
        params
      } = await handler.match(url, options);
      if (matches) {
        return {
          handler,
          index: i,
          params
        };
      }
    }
    return null;
  }
  reset() {
    this.handlers = [];
  }
  async test(url) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const found = await this.findHandler(url, options);
    return found;
  }
  async fetch(url) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const method = options && options.method || 'GET';
    try {
      const found = await this.findHandler(url, options);
      if (!found) {
        logger.debug("No matching handler found for ".concat(method, " ").concat(url, ", forwarding to legacy transport"));
        const response = await this.legacyTransport(url, options);
        const data = await response.json();
        if (!response.ok) {
          throw new Error("Legacy request failed with status ".concat(response.status, ": ").concat(data.error || response.statusText));
        }
        return data;
      }
      const {
        handler,
        index,
        params
      } = found;
      if (handler.options && handler.options.once) {
        this.handlers.splice(index, 1);
      }
      return handler.execute({
        url,
        params,
        options,
        transport: this.cloudTransport
      });
    } catch (error) {
      logger.error("Error in API Proxy for ".concat(method, " ").concat(url, ":"), error);
      throw error;
    }
  }
  static create() {
    let handlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const combinedHandlers = [...drawHandlers, ...playerHandlers, ...handlers];
    const combinedOptions = _objectSpread({}, options);
    return new ApiProxy(combinedHandlers, combinedOptions);
  }
}
if (svs.isServer) {
  module.exports = ApiProxy;
} else {
  setGlobal('svs.components.lbUtils.apiProxy.ApiProxy', ApiProxy);
}

 })(window);